import ViewTypeLabel from "views/components/ViewTypeLabel";
export default (title, type) => title != null ? title : `Unsaved ${ViewTypeLabel({ type, capitalize: true })}`;
